export const IMAGE_MAX_UPLOAD_SIZE = 3000000;
export const IMAGE_MAX_FILES = 10;
export const IMAGE_UPLOAD_ALLOWED_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
export const VACANCY_DESCRIPTION_MAX_LENGTH = 3000;
export const VACANCY_NAME_MAX_LENGTH = 60;
export const VACANCY_MAX_SPECIALITY_COUNT = 3;
export const VACANCY_LIST_OFFSET = 20;
